import { useSurvey } from "@hooks/useSurveySelectors";
import { SurveySection } from "@survey-types/survey.section.types";
import { memo } from "react";
import PDFPreview, { PDFPreviewItem } from "./PDFPreview";

interface CustomSectionPreviewProps {
  section: SurveySection;
  mode?: string;
}

const CustomSectionPreview = memo(
  ({ section }: CustomSectionPreviewProps) => {
    const survey = useSurvey();

    // Return null if section is hidden or has no PDFs
    if (section.isHidden || !section.pdfs || section.pdfs.length === 0) {
      return null;
    }

    // Convert CustomSectionPDF[] to PDFPreviewItem[]
    const pdfItems: PDFPreviewItem[] = section.pdfs
      .filter((pdf) => pdf.mediaUrl && pdf.surveySectionMediaId) // Filter out invalid items
      .map((pdf) => ({
        cloudfrontUrl: pdf.mediaUrl,
        mediaId: pdf.surveySectionMediaId,
        // thumbnailUrl is optional, CustomSectionPDF doesn't have it
      }));

    // Return null if no valid PDF items after filtering
    if (pdfItems.length === 0) {
      return null;
    }

    return <PDFPreview items={pdfItems} pdfPaperSize={survey?.pdfPaperSize} />;
  },
  (prevProps, nextProps) => {
    // Only re-render if the section's PDFs actually change, not if just the name changes
    return (
      prevProps.section.surveySectionId === nextProps.section.surveySectionId &&
      prevProps.section.isHidden === nextProps.section.isHidden &&
      JSON.stringify(prevProps.section.pdfs) ===
        JSON.stringify(nextProps.section.pdfs) &&
      prevProps.mode === nextProps.mode
    );
  },
);

CustomSectionPreview.displayName = "CustomSectionPreview";

export default CustomSectionPreview;
